module.exports = __webpack_public_path__ + "img/logo.ebeea5e5.png";